var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"root",staticClass:"diary-adv"},[(_vm.loading)?_c('div',{staticClass:"loader"},[_c('DotLoader')],1):_vm._e(),_vm._v(" "),_c('iframe',{ref:"iframe",attrs:{"src":_vm.iframeURL,"loading":"lazy"},on:{"load":_vm.loadComplete}})])}
var staticRenderFns = []

export { render, staticRenderFns }